import type { MappedOffer } from '../types';

/**
 * Should look differences only by ADT type
 * because there is at least one adult in any flight
 */

export const isDifferentBaggages = (offer: MappedOffer) => {
  if (!offer.flights) {
    return false;
  }
  const targetKey = 'ADT';
  const firstBaggage = offer.flights[0].segments[0].baggage.free[targetKey];

  return offer.flights.some(flight =>
    flight.segments.some(
      segment => segment.baggage.free[targetKey]?.value !== firstBaggage?.value,
    ),
  );
};
